import { firebaseFunctionCommands } from '../commands/firebase-function-commands';
import type { CommandClient, ProjectWriteClient } from '../contracts';
import type {
  ApplyProjectWritesRequest,
  ApplyProjectWritesResponse,
  ResolveProjectWriteConflictRequest,
  ResolveProjectWriteConflictResponse,
} from '@/features/sync/project-write-authority-api';

export class FirebaseProjectWriteClient implements ProjectWriteClient {
  private readonly commands: CommandClient;

  constructor(commands: CommandClient) {
    this.commands = commands;
  }

  applyProjectWrites(
    request: ApplyProjectWritesRequest,
  ): Promise<ApplyProjectWritesResponse> {
    return this.commands.call(firebaseFunctionCommands.applyProjectWrites, request);
  }

  resolveProjectWriteConflict(
    request: ResolveProjectWriteConflictRequest,
  ): Promise<ResolveProjectWriteConflictResponse> {
    return this.commands.call(
      firebaseFunctionCommands.resolveProjectWriteConflict,
      request,
    );
  }
}
